import InstallationPlaning from './InstallationPlaning';

export default InstallationPlaning